<template>
  <div class="info-block">
    <div class="d-flex justify-content-start mb-2">
      <Skeleton v-if="loading" width="18px" height="18px" />
      <a-icon v-else :type="icon" class="font-size-18" />
    </div>
    <Skeleton v-if="loading" width="80px" height="14px" class="mb-1" />
    <span v-else class="title">{{ title }}</span>
    <div class="d-flex justify-content-between">
      <Skeleton v-if="loading" width="180px" height="16px" />
      <span v-else class="value">{{ value }}</span>
      <slot name="action" />
    </div>
  </div>
</template>

<script>
import Skeleton from '@/components/custom/skeleton/Skeleton.vue'

export default {
  props: {
    icon: {
      type: String,
      default: 'user',
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Skeleton,
  },
}
</script>

<style lang="scss">
.info-block {
  display: flex;
  flex-direction: column;
  border: 1px solid #c8cdd3;
  border-radius: 5px;
  padding: 10px 20px;
  min-width: 200px;
  .title {
    font-weight: bold;
    color: #c8c4db;
    font-size: 14px;
  }
  .value {
    font-size: 16px;
  }
}
</style>
